import { BlockchainContext } from "../context/BlockchainContext";
import { useContext, useState } from "react";

export default function StakeNFT() {
  const {
    approve,
    unstakeall,
    grabNFTStakeData,
    StakeAll,
    grabNFTrewards,
    claimit,
    connectWallet,
  } = useContext(BlockchainContext);
  async function refreshPage() {
    {
      connectWallet();
    }
  }

  return (
    <div className="transform">
      <div className="gridbox">
        <div className="gridbutton" onClick={refreshPage}>
          Connect
        </div>{" "}
        <p className="boxNumber">NFT Staking</p>
        <div className="gridbutton" onClick={approve}>
          Approve
        </div>
      </div>
      <div className="boxes">
        <div className="box">
          <div className="boxheader">Total NFTs Staked</div>
          <div className="boxinfo">
            <div id="totalnftstaked"></div>
          </div>
        </div>
        <div className="box">
          <div className="boxheader">Unclaimed Rewards</div>
          <div className="boxinfo">
            <div id="earned"></div>
          </div>
        </div>
        <div className="box">
          <div className="boxheader">Your IDs Staked</div>
          <div className="boxinfo">
            <div id="getstakednfts"></div>
          </div>
        </div>
      </div>
      <div className="boxes2">
        <div className="box">
          <div className="boxheader"> Stake All</div>
          <div className="boxbutton" onClick={StakeAll}>
            Stake
          </div>
        </div>
        <div className="box">
          <div className="boxbutton" onClick={claimit}>
            Claim
          </div>
        </div>
        <div className="box">
          <div className="boxheader">Unstake All</div>
          <div className="boxbutton" onClick={unstakeall}>
            Unstake
          </div>
        </div>
      </div>
      <div className="boxes2">
        <div className="box">
          <a className="boxbutton" href="https://spookysushi.com/">
            Website
          </a>
        </div>{" "}
        <div className="box">
          <a
            className="boxbutton"
            href="https://nftrade.com/collection/spookysushinft-v1"
          >
            Trade NFTs
          </a>
        </div>
      </div>
      <div className="nullBox">
        <div id="APR"></div>
        <div id="StakedTokens"></div>
        <div id="balance"></div>
        <div id="pendingRewards"></div>
        <div id="depositedTokens"></div>
        <div id="earned"></div>
        <div id="getstakednfts"></div>
        <div id="costofmint"></div>
        <div id="totalSupply"></div>
        <div id="maxSupply"></div>
        <div id="totalnftstaked"></div>
        <div id="earned"></div>
        <div id="userLocked"></div>
        <div id="lockedPendingRewards"></div>
        <div id="holderUnlockTime"></div>
        <div id="lockedAPR"></div> <div id="totalLockedStake"></div>{" "}
        <div id="exitPenaltyPerc"></div> <div id="LockedTokenBalance"></div>{" "}
      </div>{" "}
    </div>
  );
}
